import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import MuiLink from '@material-ui/core/Link';
import withThemeProps from '../withThemeProps';
import useMuiComponentsSettings from '../useMuiComponentsSettings';
/**
 *
 * @param {*} param0
 */

function Link(_ref) {
  var component = _ref.component,
      props = _objectWithoutProperties(_ref, ["component"]);

  var linkComponent = useMuiComponentsSettings('linkComponent');
  return React.createElement(MuiLink, _extends({
    component: component || linkComponent
  }, props));
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   *
   */
  component: PropTypes.elementType,

  /**
   * Cesta externej linky. Vzdy presmeruje "na externu stranky".
   *
   * Ak je relativna aj tak dojde k reloadu stranky.
   */
  href: PropTypes.string,

  /**
   * Lokalna cesta
   */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string,
    state: PropTypes.object
  })]),
  underline: PropTypes.oneOf(['none', 'hover', 'always']),
  variant: PropTypes.string
};
Link.defaultProps = {
  color: 'primary',
  component: undefined,
  href: undefined,
  to: undefined,
  underline: 'hover',
  variant: 'body1'
};
export default withThemeProps({
  name: 'SxLink'
})(Link);